import { useState } from "react";
import { Button } from "react-bootstrap";
import HonorariosTable from "../../../components/Tables/HonorariosTable";
import { useHonorarios } from "../../../hooks/useHonorarios";
import FormHonorario from "./FormHonorario";

function Honorarios() {
  const {
    honorarios,
    isFetching,
    isLoading,
    createHonorario,
    updateHonorario,
    deleteHonorario,
    isCreating,
    isUpdating,
    isDeleting,
  } = useHonorarios();

  const [showForm, setShowForm] = useState(false);
  const [editingHonorario, setEditingHonorario] = useState(null);

  const openCreate = () => {
    setEditingHonorario(null);
    setShowForm(true);
  };

  const openEdit = (honorario) => {
    setEditingHonorario(honorario);
    setShowForm(true);
  };

  const closeForm = () => {
    setShowForm(false);
    setEditingHonorario(null);
  };

  const handleSubmit = async (payload) => {
    if (editingHonorario?.id) {
      await updateHonorario({ id: editingHonorario.id, ...payload });
    } else {
      await createHonorario(payload);
    }
    closeForm();
  };

  const handleDelete = async (honorario) => {
    const label =
      honorario.client ||
      honorario.type ||
      `honorário #${honorario.id}`;
    const confirmed = window.confirm(`Excluir o honorário "${label}"?`);
    if (!confirmed) return;
    await deleteHonorario(honorario.id);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <div>
          <h5 className="mb-0">Honorários</h5>
          <small className="text-muted">
            Contratos de honorários com saldo (contratado − recebido).
          </small>
        </div>
        <Button
          type="button"
          className="btn-bg-primary text-dark borderColor"
          onClick={openCreate}
        >
          <i className="bi bi-plus-lg" /> Novo Honorário
        </Button>
      </div>

      <HonorariosTable
        isFetching={isLoading || isFetching}
        honorarios={honorarios}
        onEdit={openEdit}
        onDelete={handleDelete}
        isDeleting={isDeleting}
      />

      <FormHonorario
        show={showForm}
        onHide={closeForm}
        honorario={editingHonorario}
        onSubmit={handleSubmit}
        isSubmitting={isCreating || isUpdating}
      />
    </div>
  );
}

export default Honorarios;
